module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABLklEQVQ4jaWUPUsDQRCGnxg7sbbQwlJtgiIoGAJip42NRWwE/4WNpa3/QCyCIHZaRa0sRGwECVinkAgKithYvTJyJ5tjJ7fEF+Y4mJlnPm73KpKIqA6sA8vAPFAFOsAtcJlZvwwU2ISklsp1LmkmzA0hs5LeEyChGnl+Pto40APGYnOWaBrojmQxrSEhpovfp6Qlp+1PSU1Jxwkjbhro0HG2g/1tS3odADqz0VYS2j8B5oBTx1+zal9OlevC0chtJxL7YR1FT+QAPUdcowZ6cnKKBex0HwBXkdg3A907oO/gvZEV3HNiOzbzmrOjnqS6pP2ST2/azRd4kxDsqSupmoOm/gFaLF7a1SEgW7Hbb1aTdJcAeMwK/+V6P7YmsAEsAJNABXgBHoA2cNQXDfwAXf29Xg/jHpwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon8.png
// module id = 4Rzw
// module chunks = 0